import _get from 'lodash.get';

const isExperimentEnabled = (state, path, template, experimentName) => {
  if (state && path && template && experimentName) {
    let enabledSections =
      _get(state, `common.siteConfig.${experimentName}.sections`) || [];
    let enabledTemplates =
      _get(state, `common.siteConfig.${experimentName}.templates`) || [];

    if (typeof enabledSections === 'string') {
      enabledSections = [enabledSections];
    }
    if (typeof enabledTemplates === 'string') {
      enabledTemplates = [enabledTemplates];
    }
    const isTemplateMatches =
      enabledTemplates && enabledTemplates?.includes(template);
    const isSectionMatches =
      enabledSections &&
      enabledSections.some(enabledSection => path.includes(enabledSection));

    if (enabledTemplates?.includes('all') && enabledSections?.includes('all')) {
      return true;
    }
    if (
      enabledTemplates?.includes('all') &&
      !enabledSections?.includes('all')
    ) {
      return isSectionMatches;
    }
    if (
      enabledSections?.includes('all') &&
      !enabledTemplates?.includes('all')
    ) {
      return isTemplateMatches;
    }
    return isTemplateMatches && isSectionMatches;
  }
  return undefined;
};

export default isExperimentEnabled;
